export const campaignCreationSearchShoppingStyles = ({ palette = {} }) => ({
  '& a.brands_url_link, & .bmc_url_link': {
    textDecoration: 'underline',
  },
  '& .location-manage': {
    '& .location-popup-editor .ba-backbone-instance-wrapper>div': {
      padding: 0,
    },
  },
  '& .ba-backbone-instance-wrapper': {
    '& >div': {
      padding: '20px 32px',
      width: '100%',
    },

    '& .name, & .store, & .countryChange, & .bid-setting__container .input-group': {
      width: 438,
    },

    '& .bid-warning': {
      marginTop: 6,
    },

    '& .budget-amount': {
      width: '313px !important',
    },

    '& .bidding-strategy__container': {
      '& .col-sm-6': {
        width: 438,
        boxSizing: 'content-box',
        paddingTop: 5,

        '& > .form-control-static': {
          paddingBottom: 8,
          minHeight: 1,
        },
      },
    },

    '& h1': {
      margin: 0,
      fontSize: 20,
      color: palette.neutralPrimary,
    },
    '& h3': {
      fontSize: 14,
      color: palette.neutralPrimary,
      margin: '14px 0',
      fontWeight: 'normal',
    },

    '& hr': {
      marginTop: -29,
      background: palette.neutralSecondary,
      height: '1px',
    },

    '& .type-bold': {
      fontSize: 18,
      margin: '40px 0 0 0',
    },

    '& .advanced-settings-section': {
      borderTop: 0,
      marginTop: 0,
      paddingTop: 33,
    },

    '& .location-target-done': {
      marginLeft: 15,
      marginRight: 12,
    },

    '& .save-bar': {
      borderTop: `1px solid ${palette.neutralLight}`,
      paddingTop: 16,

      '& .btn-save': {
        marginRight: 12,
      },
    },

    '& .no-stores-message': {
      lineHeight: '48px',
    },

    '& .brands_url_link': {
      textDecoration: 'underline',
      verticalAlign: 'middle',
      '& span': {
        verticalAlign: 'baseline',
      },
    },

    '& .feed-product-filter': {
      marginTop: 33,
      '& .all-feed-products': {
        alignItems: 'center',
        display: 'flex',
      },
      '& .filter-offset': {
        marginLeft: 25,
      },
    },

  },
  '& .bmc_url_link': {
    display: 'inline-block',
    margin: '25px 0 25px 5px',
  },
});
